import { useNotifications } from '@novu/react';
import { useQuery } from '@tanstack/react-query';
import { Divider, Modal } from 'antd';
import { format, isAfter, parseISO, subDays } from 'date-fns';
import DOMPurify from 'dompurify';
import { useAtom } from 'jotai';
import { atomTree } from 'jotai-family';
import { atomWithStorage } from 'jotai/utils';
import { useEffect, useMemo, useState } from 'react';
import { queryMe } from '../../me/api';
import { RichText } from './rich-text';

const today = Date.now();

const tree = atomTree((path: string[]) =>
  atomWithStorage<number | null>(`${path.join('_')}_notificationsSeenAt`, null),
);

export function AnnouncementModal() {
  const { data } = useQuery(queryMe);
  const [visible, setVisible] = useState(false);

  const [timestamp, setTimestamp] = useAtom(tree([data.name]));

  const { notifications } = useNotifications({
    archived: false,
    createdGte: subDays(today, 7).getTime(),
  });

  const newNotifications = useMemo(() => {
    return notifications
      ?.filter((item) => !item.isArchived)
      .filter(
        (item) =>
          timestamp == null || isAfter(parseISO(item.createdAt), timestamp),
      );
  }, [notifications, timestamp]);

  useEffect(() => {
    if (newNotifications?.length) {
      setVisible(true);
    }
  }, [newNotifications]);

  return (
    <Modal
      title="系统公告"
      open={visible}
      centered
      width={800}
      mask={{ closable: false }}
      classNames={{
        title: '!text-2xl !font-bold',
        body: 'max-h-[75vh] overflow-auto',
      }}
      onCancel={() => {
        setVisible(false);
        setTimestamp(Date.now());
      }}
      footer={null}
    >
      {notifications?.map((item, index) => (
        <div>
          {index !== 0 && <Divider></Divider>}
          <h1 className="mb-2 text-xl font-bold">{item.subject}</h1>
          <RichText
            inline
            readonly
            value={DOMPurify.sanitize(item.body)}
          ></RichText>
          <div className="mt-2 text-gray-500">
            日期：{format(item.createdAt, 'yyyy-MM-dd')}
          </div>
        </div>
      ))}
    </Modal>
  );
}
